module.exports = __webpack_public_path__ + "static/media/bat_exec_2.51e66ed0.ico";